<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-skip"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-head">
                    <div>{{title}}</div>
                </div>
                <div class="modal-base-body">
                    <div class="special-text">
                        <div class="text-description text-center ">
                            <div class="wrap-text" v-html="message"></div>
                        </div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div class="btn-ok-wrapper">
                        <div class="btn-ok" @click="clickOk()">
                           {{btnOk}}
                        </div>
                    </div>
                    <div class="btn-cancel-wrapper">
                        <div class="btn-cancel" @click="hide()">
                            {{lbl.modalSkip.btn_cancel}}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import Locale from "@/helper/locale/locale.js";
/**
 * @property {SkipModalController} controller (required)../Controller/SkipModalController.js
 * @property {String} modalId (reqquired)
 */
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "SkipModal",
    props: {
        controller: Object,
        modalId: String
    },
    components: {},
    mixins: [LocaleMixin],
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            busModal: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/baseImage.scss";
@import "@/style/base/baseText.scss";
.text-description {
    .wrap-text {
        @extend %ellipsis-2;
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-skip {
    @extend %modal-base;
    color: $bright-gray;
    font-size: 1rem;
    .modal-body {
        padding: 25px;
    }
    .modal-dialog {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        margin: 0;
        .modal-content {
            box-shadow: 0 -3px 6px 0 rgba(0, 0, 0, 0.07);
            border-radius: 0;
            border-top-left-radius: 30px;
            border-top-right-radius: 30px;
            border: 0;
            font-family: $medium;

            .modal-base-head {
                color: $deep-blue;
                font-size: 1.2rem;
                letter-spacing: 1.1px;
                text-align: center;
                margin: 10px 0px 20px 0px;
            }

            .text-description {
                padding: 10px 0px;
                font-size: 1.2rem;
                text-align: center;
            }

            .modal-base-footer {
                padding-top: 25px;
                .btn-ok-wrapper {
                    margin-bottom: 12px;
                    font-size: 1.2rem;
                    .btn-ok {
                        color: $white;
                        background: $deep-blue;
                        text-align: center;
                        padding: 12px 20px;
                        border-radius: 50px;
                        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
                    }
                }
                .btn-cancel-wrapper {
                    margin-bottom: 10px;
                    font-size: 1.2rem;
                    .btn-cancel {
                        color: $blue-gray;
                        background: $white;
                        text-align: center;
                        padding: 10px 20px;
                        border-radius: 50px;
                        border: solid 2px $blue-gray;
                        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
                    }
                }
            }
        }
    }
}
</style>
